module.exports = __webpack_public_path__ + "media/images/golden_pin_concept_design_award_img-1bdf620a82c927a32391409a59a4b5e9.jpg";